import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages: {}, // Start with an empty messages object
});

// // Load translations asynchronously when the app initializes
// loadTranslations().then((messages) => {
//   console.log(messages);
//   i18n.setLocaleMessage('en', messages.en); // Set translations for 'en' locale
// });
// console.log(i18n);
export default i18n;
